import React, { useState } from "react";
import { Button, TimePicker } from "antd";
import { HorizontalGap, VerticalGap } from "../styled/gaps";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const AddSlot = (props) => {
  const [slot, setSlot] = useState([]);
  const [slotString, setSlotString] = useState([]);
  const onChange = (time, timeString) => {
    // props.changeHandler(time, timeString);
    // alert(JSON.stringify(timeString));
    setSlot(time);
    setSlotString(timeString);
    // alert(JSON.stringify(timeString));
  };

  return (
    <Container>
      <TimePicker.RangePicker
        popupStyle={{ zIndex: 2000 }}
        use12Hours
        format={"hh:mm A"}
        showNow={false}
        minuteStep={15}
        onChange={onChange}
        value={[...slot]}
      />
      <HorizontalGap size={"10px"} />
      <Button
        disabled={!slot.length}
        type="primary"
        onClick={() => {
          // let newData = JSON.parse(JSON.stringify(data));
          // newData.push(newSlot);
          // setData(newData);
          // setNewSlot(null);
          props.addHandler(slot, slotString);
          setSlot([]);
          setSlotString([]);
        }}
      >
        Add Slot
      </Button>
    </Container>
  );
};

export { AddSlot };
